import CreateSummaryView from "@features/tools/view/summaries-view/create-summary-view";

const CreateSummary = () => {
  return <CreateSummaryView />;
};

export default CreateSummary;
